module.exports = __webpack_public_path__ + "assets/img/AboutUsBAIOS.cba1f3b1.png";